module.exports = __webpack_public_path__ + "static/media/hn.81ab9078.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/hn.svg
// module id = 142
// module chunks = 0